import Vue from 'vue'
import VueRouter from 'vue-router'

import Tos from '../views/Tos.vue'
import Faq from '../views/Faq.vue'
// import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Catalog from '../views/Catalog.vue'
import Category from '../views/Category.vue'
import Checkout from '../views/Checkout.vue'
import Warranty from '../views/Warranty.vue'
import Product from '../views/Product.vue'
import Order from '../views/Order.vue'
import Landing from '../views/Landing.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/tos',
    name: 'Tos',
    component: Tos
  }, {
    path: '/faq',
    name: 'Faq',
    component: Faq
  }, {
    path: '/warranty',
    name: 'Warranty',
    component: Warranty
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }, {
    path: '/catalog',
    name: 'Catalog',
    component: Catalog
  }, {
    path: '/catalog/:slug',
    name: 'Category',
    component: Category
  }, {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  }, {
    path: '/products/:slug',
    name: 'Product',
    component: Product
  }, {
    path: '/orders/:id',
    name: 'Order',
    component: Order
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router
